import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { UntypedFormControl, Validators } from '@angular/forms';
import { DataTableColumn, PaginatorStatus, SortConfiguration } from '../../generics/data-table/data-table.component';
import { CustomTableFilter } from '../../generics/table-filter/table-filter.component';
import { ErrorResponse } from 'src/app/models/error.model';
import { TipoDescuento } from 'src/app/models/tipo-descuento.model';
import { DescuentoProducto } from 'src/app/models/descuento-producto.model';
import { TiposDescuentoService } from 'src/app/services/tipos-descuento.service';
import { DescuentoProductoService } from 'src/app/services/descuento-producto.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-tipos-descuento',
    templateUrl: './tipos-descuento.component.html',
    styleUrls: ['./tipos-descuento.component.scss']
})
export class TiposDescuentoComponent implements OnInit {

    @ViewChild('topeColumnTemplate', { static: true })
    topeColumnTemplate: TemplateRef<any>;

    @ViewChild('activoColumnTemplate', { static: true })
    activoColumnTemplate: TemplateRef<any>;

    @ViewChild('actionsColumnTemplate', { static: true })
    actionsColumnTemplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Nombre', prop: 'nombre', sortable: true },
        { name: 'Descuento', width: '120px' },
        { name: 'Estado', width: '100px' },
        { name: '', width: '100px' }
    ];

    sortConfiguration?: SortConfiguration;
    tiposDescuento: TipoDescuento[] = [];

    filters: CustomTableFilter[] = [
        { key: 'nombre', description: 'Nombre', type: 'STRING' }
    ];
    filterValues: any = {};

    descuentoProductoControl = new UntypedFormControl(null, [Validators.required, Validators.min(0), Validators.max(100)]);

    constructor(
        private tiposDescuentoService: TiposDescuentoService,
        private descuentoProductoService: DescuentoProductoService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === 'Descuento').template = this.topeColumnTemplate;
        this.columns.find(col => col.name === 'Estado').template = this.activoColumnTemplate;
        this.columns.find(col => col.name === '').template = this.actionsColumnTemplate;
        this.getTiposDescuento();
        this.getDescuentoProducto();
    }

    getDescuentoProducto() {
        this.descuentoProductoService.getDescuentoProducto().subscribe({
            next: (descuentoProducto: DescuentoProducto) => this.descuentoProductoControl.setValue(descuentoProducto.tasa),
            error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener el Descuento de producto', error.error?.descripcion)
        });
    }

    saveDescuentoProducto() {
        if (!this.descuentoProductoControl.valid) {
            this.descuentoProductoControl.markAsTouched();
            return;
        }
        this.descuentoProductoService.updateDescuentoProducto({ tasa: this.descuentoProductoControl.value }).subscribe({
            next: () => this.utilsService.alert('Descuento de producto actualizado', 'La tasa global fue actualizada correctamente.'),
            error: (error: ErrorResponse) => this.utilsService.alert('Error al actualizar el Descuento de producto', error.error?.descripcion)
        });
    }

    getTiposDescuento() {
        this.tiposDescuentoService.getTiposDescuento(
            this.paginatorStatus.page,
            this.paginatorStatus.itemsPerPage,
            this.sortConfiguration ? [this.sortConfiguration] : [],
            this.filterValues
        ).subscribe({
            next: response => {
                this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.tiposDescuento = response.body;
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener tipos de descuento', error.error?.descripcion)
        });
    }

    updatePage(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getTiposDescuento();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getTiposDescuento();
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getTiposDescuento();
    }

    deleteTipoDescuento(tipoDescuento: TipoDescuento) {
        const dialog = this.utilsService.confirm(
            '¿Dar de baja este tipo de descuento?',
            `El tipo de descuento "${tipoDescuento.nombre}" quedará inactivo.`
        );
        dialog.afterClosed().subscribe(confirmed => {
            if (confirmed) {
                this.tiposDescuentoService.deleteTipoDescuento(tipoDescuento.id).subscribe({
                    next: () => {
                        this.utilsService.alert('Tipo de descuento dado de baja', `"${tipoDescuento.nombre}" fue dado de baja correctamente.`);
                        this.getTiposDescuento();
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al dar de baja', error.error?.descripcion)
                });
            }
        });
    }
}
